import React from 'react';
import Helmet from 'react-helmet';

import * as GetFrontEndSettingService from '../../../service/GetFrontEndSettingService';
import * as callApiUtil from '../../../utils/callApiUtil';

class newHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nonJQueryHTML: null,
      loginStatus: null,
      isLoadingLoginStatus: true,
      isLoadingMetaDataTag: true,
      isLoadHeaderDone: false,
      baseUrl: process.env.REACT_APP_HEADER_URL,
    };
  }

  async loadHeaderWebComponents() {
    try {
      const loadResource = (tag, attributes) => {
        return new Promise((resolve, reject) => {
          const element = document.createElement(tag);
          Object.keys(attributes).forEach((key) => element.setAttribute(key, attributes[key]));
          element.onload = resolve;
          element.onerror = reject;
          document.head.appendChild(element);
        });
      };
      const loadScript = (src) => loadResource('script', { src, type: 'module' });
      const loadCss = (href) => loadResource('link', { href, rel: 'stylesheet' });

      await loadScript(`${process.env.REACT_APP_HEADER_WEB_COMPONENT}/header-web-component.esm.js`);
      loadCss(`${process.env.REACT_APP_HEADER_WEB_COMPONENT}/header-web-component.css`);
    } catch (error) {
      console.error('Error Loading Header Web Component', error);
    } finally {
      this.setState({ isLoadHeaderDone: true });
    }
  }

  componentDidMount() {
    this.loadHeaderWebComponents();

    callApiUtil
      .callApi('/eservice/api/authorizationController/getLoginStatus', {}, null, null, false, true)
      .then((data) => {
        if (data && data.processResult && data.processResult.status === 's') {
          this.setState({
            loginStatus: data.loginStatus,
          });
        }
      })
      .finally(() => {
        this.setState({
          isLoadingLoginStatus: false,
        });
      });

    // 後端取得各頁面的 MetaTag 並串在 Header 上
    GetFrontEndSettingService.getMetaDataTag(window.location.pathname)
      .then((data) => {
        document.querySelector('head').innerHTML += data.metaData;
      })
      .finally(() => {
        this.setState({
          isLoadingMetaDataTag: false,
        });
      });
  }

  componentDidUpdate() {
    if (this.state.isLoadHeaderDone && !this.state.isLoadingLoginStatus && !this.state.isLoadingMetaDataTag) {
      this.props.callback();
    }
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          {/* 有吃到這份 CSS 設定，暫時保留並 minify (mothra-header-footer.css) */}
          <link rel='stylesheet' href={`${process.env.PUBLIC_URL}/css/mothra-header-footer.min.css`} />

          {/* fetnet_common.js：Prod 版本有載入 GTM 的程式碼 (暫時保留)*/}
          <script src={this.state.baseUrl + '/home/rwd/CommonPage/js/fetnet_common.js'} defer></script>
        </Helmet>

        <header className='fui-header is-fixed'>
          <header-component
            logout-callback-url={process.env.REACT_APP_LOGOUT_REDIRECT_URL}
            init-activity-map-tracking='true'
          />
        </header>
      </React.Fragment>
    );
  }
}

export default newHeader;
